// extracted by mini-css-extract-plugin
export default {"primaryColor":"var(--primary-color)","secondaryColor":"var(--secondary-color)"};